import React, { useState } from 'react';
import {Form, Row, Col, Input, Button, Card, Select, Checkbox, DatePicker, Upload} from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import SelectData from './selectdata';
import Config from "./config";
import axios from "axios";
import moment from "moment";
import {CisUI} from "./CISUI";
import StaticSelectData from "./StaticSelectData";

const { RangePicker } = DatePicker;
const { Option } = Select;
const {TextArea} = Input;


const formItemLayout = {
    labelCol: {
        span: 24,
    },
    wrapperCol: {
        span: 24,
    },
};

const onRangeChange = (value, dateString) => {
    console.log('Selected Time: ', value);
    console.log('Formatted Selected Time: ', dateString);
}

const dateFormat = 'YYYY/MM/DD';

const AdvancedSearch = (inputs,endpoint="/",hasDataRange=0,pickertype="") => {
    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();
    const getFields = () => {
        const count = inputs.length;
        const children = [];
        let hasSearch = 0;
        //const allinputs = inputs;
            inputs.map((list, index) => {
                if (list.isFilterable == 1) {
                    hasSearch = 1;
                    let field = "";
                    if (list.type == 'text' || list.type == 'phone' || list.type == 'email') {
                        field = <Form.Item
                            name={`${list.name}`}
                            label={`${list.label}`}
                            rules={[
                                {
                                    required: false,
                                    message: list.placeholder
                                },
                            ]}
                        >
                            <Input placeholder={list.label}/>
                        </Form.Item>
                    } else if(list.type == 'date'){
                        field = <Form.Item
                            name={`${list.name}`}
                            label={`${list.label}`}
                            rules={[
                                {
                                    required: false,
                                    message: list.placeholder
                                },
                            ]}
                        >
                            <DatePicker  className="gx-mb-3 gx-w-100" placeholder={list.placeholder}/>
                        </Form.Item>
                    } else if (list.type == 'select') {

                        if(list.name === 'company_id' || list.name === 'com_id') {
                            const companyID = CisUI().getUserInfo('com_id');
                            if(companyID > 0) {

                            }
                            else {
                                const dataOptions = SelectData(list.data);
                                const dataOptions1 = StaticSelectData(list.name);
                                // console.log("CompanyList : "+dataOptions);

                                field = <Form.Item
                                    name={`${list.name}`}
                                    label={`${list.label}`}
                                    rules={[
                                        {
                                            required: false,
                                            message: list.placeholder
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        allowClear={true}
                                        placeholder={list.placeholder}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            list.isStatic === 1 && (
                                                dataOptions1.map((items, index) =>
                                                    <Option key={++index} value={items.id}>{items.name}</Option>
                                                )
                                            )
                                        }
                                        {
                                            dataOptions.map((items) =>
                                                <Option value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            }
                        }
                        else {
                            const dataOptions = SelectData(list.data);
                            const dataOptions1 = StaticSelectData(list.name);
                            // console.log("CompanyList : "+dataOptions);

                            field = <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: false,
                                        message: list.placeholder
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    allowClear={true}
                                    placeholder={list.placeholder}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {
                                        list.isStatic === 1 && (
                                            dataOptions1.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        )
                                    }
                                    {
                                        dataOptions.map((items) =>
                                            <Option value={items.id}>{items.name}</Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                        }
                    }
                    if(field != '') {
                        children.push(
                            <Col lg={6} md={6} sm={12} xs={24} key={index}
                                 style={{display: index < count ? 'block' : 'none'}}>
                                <div className="gx-form-row0">
                                    {field}
                                </div>
                            </Col>,
                        );
                    }
                }
            });

            if(hasDataRange === 1) {
                hasSearch = 1;
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} >
                        <div className="gx-form-row0">

                            <Form.Item
                                name="date"
                                label="Date"
                                rules={[
                                    {
                                        required: false,
                                        message: "Start Date"
                                    },
                                ]}
                            >

                                <RangePicker onChnage={onRangeChange} format={CisUI().dateFormat} />

                                {/*<DatePicker format={CisUI().dateFormat} placeholder="Start Date"/>*/}
                            </Form.Item>

                        </div>
                    </Col>,
                );
            }

        if(pickertype === "week") {
            hasSearch = 1;
            children.push(
                <Col lg={6} md={6} sm={12} xs={24} >
                    <div className="gx-form-row0">

                        <Form.Item
                            name={pickertype}
                            label="Week"
                            rules={[
                                {
                                    required: false,
                                    message: {pickertype}
                                },
                            ]}
                        >

                            <DatePicker picker={pickertype} onChnage={onRangeChange} />
                        </Form.Item>

                    </div>
                </Col>,
            );
        }

        if(pickertype === "month") {
            hasSearch = 1;
            children.push(
                <Col lg={6} md={6} sm={12} xs={24} >
                    <div className="gx-form-row0">

                        <Form.Item
                            name={pickertype}
                            label="Month"
                            rules={[
                                {
                                    required: false,
                                    message: {pickertype}
                                },
                            ]}
                        >

                            <DatePicker picker={pickertype} onChnage={onRangeChange} />
                        </Form.Item>

                    </div>
                </Col>,
            );
        }

            if(hasSearch === 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} style={{textAlign: 'left'}}>
                        <br/>
                        <Button type="primary" className="searchbutton" htmlType="submit">
                            <i class="fas fa-search"></i> Search
                        </Button>
                    </Col>
                )
            }

        return children;
    };

    // const onFinish = values => {
    //     console.log('Received values of form: ', values);
    // };

    return (
        <Row gutter={24}>
            {getFields()}
        </Row>
    );
};

export default AdvancedSearch;
